module.exports = __webpack_public_path__ + "img/pol.78bf8d48.svg";